<script setup lang="ts">
/**
 * 无限滚动跑马灯 — Inspira UI
 * 文档：https://inspira-ui.com/docs/en/components/miscellaneous/marquee
 */
import { cn } from '@inspira-ui/plugins';

withDefaults(
  defineProps<{
    class?: string;
    reverse?: boolean;
    pauseOnHover?: boolean;
    /** 外部控制暂停（如离开视口） */
    paused?: boolean;
    vertical?: boolean;
    repeat?: number;
  }>(),
  {
    pauseOnHover: false,
    paused: false,
    vertical: false,
    repeat: 4,
  },
);
</script>

<template>
  <div
    :class="
      cn(
        'flex gap-(--gap) overflow-hidden p-2 [--duration:40s] [--gap:1rem]',
        vertical ? 'flex-col' : 'flex-row',
        pauseOnHover && 'marquee-pause-on-hover',
        paused && 'marquee-is-paused',
        $props.class,
      )
    "
  >
    <div
      v-for="index in repeat"
      :key="index"
      :style="{
        animationDirection: reverse ? 'reverse' : 'normal',
      }"
      :class="
        cn(
          'flex shrink-0 justify-around gap-(--gap)',
          vertical ? 'animate-marquee-vertical flex-col' : 'animate-marquee flex-row',
        )
      "
    >
      <slot />
    </div>
  </div>
</template>

<style scoped>
.animate-marquee {
  animation: marquee var(--duration) linear infinite;
  animation-direction: reverse;
}

.animate-marquee-vertical {
  animation: marquee-vertical var(--duration) linear infinite;
}

.marquee-pause-on-hover:hover .animate-marquee,
.marquee-pause-on-hover:hover .animate-marquee-vertical,
.marquee-is-paused .animate-marquee,
.marquee-is-paused .animate-marquee-vertical {
  animation-play-state: paused;
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - var(--gap)));
  }
}

@keyframes marquee-vertical {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(calc(-100% - var(--gap)));
  }
}
</style>
